import { useState, useEffect, useRef, useCallback } from 'react';

/**
 * useOrderCollapse — maneja el modo colapsable de la columna de orden (solo desktop).
 * - pinned: fija abierta (persiste en localStorage). Por defecto: true.
 * - hovering: se está encima de la columna/viñeta.
 * expanded = pinned || hovering. En móvil siempre expanded (no aplica).
 */
const STORAGE_KEY = 'sp_order_pinned';

export function useOrderCollapse() {
   const [pinned, setPinned] = useState(() => {
      try {
         const saved = localStorage.getItem(STORAGE_KEY);
         return saved === null ? true : saved === '1';
      } catch {
         return true;
      }
   });
   const [hovering, setHovering] = useState(false);
   const closeTimer = useRef(null);

   // Persiste el valor por defecto la primera vez (si no existía la key)
   useEffect(() => {
      try {
         if (localStorage.getItem(STORAGE_KEY) === null) {
            localStorage.setItem(STORAGE_KEY, pinned ? '1' : '0');
         }
      } catch {}
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   const togglePin = useCallback(() => {
      setPinned(p => {
         const next = !p;
         try { localStorage.setItem(STORAGE_KEY, next ? '1' : '0'); } catch {}
         return next;
      });
   }, []);

   // hover con pequeño delay al salir (evita parpadeo)
   const onEnter = useCallback(() => {
      if (closeTimer.current) { clearTimeout(closeTimer.current); closeTimer.current = null; }
      setHovering(true);
   }, []);

   const onLeave = useCallback(() => {
      closeTimer.current = setTimeout(() => setHovering(false), 180);
   }, []);

   useEffect(() => () => { if (closeTimer.current) clearTimeout(closeTimer.current); }, []);

   const expanded = pinned || hovering;
   return { pinned, togglePin, expanded, hovering, onEnter, onLeave };
}

export default useOrderCollapse;